import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { MetadataUploadForm, MetadataItem } from './components/MetadataUploadForm';
import { MetadataEditForm } from './components/MetadataEditForm';
import { MetadataDeleteConsole } from './components/MetadataDeleteConsole';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  // New metadata management state
  const [metadata, setMetadata] = useState<MetadataItem[]>([
    {
      id: '1',
      name: 'Premium Black Leather Texture',
      displayName: 'Premium Black Leather Texture',
      imageType: 'background',
      campaignTypes: ['vehicle', 'incentive'],
      categories: ['textures', 'fabric'],
      fileName: 'texture_black-leather.jpg'
    },
    {
      id: '2',
      name: 'Natural Wood Grain Pattern',
      displayName: 'Natural Wood Grain Pattern',
      imageType: 'foreground',
      campaignTypes: ['vehicle'],
      categories: ['textures', 'wood'],
      fileName: 'texture_wood-grain.jpg'
    },
    {
      id: '3',
      name: 'Industrial Steel Surface',
      displayName: 'Industrial Steel Surface',
      imageType: 'background',
      campaignTypes: ['incentive'],
      categories: ['textures', 'metal'],
      fileName: 'texture_steel.jpg'
    },
    {
      id: '4',
      name: 'High-Tech Carbon Fiber',
      displayName: 'High-Tech Carbon Fiber',
      imageType: 'background',
      campaignTypes: ['vehicle', 'premium'],
      categories: ['textures', 'composite'],
      fileName: 'texture_carbon-fiber.jpg'
    },
    {
      id: '5',
      name: 'Luxurious Red Fabric',
      displayName: 'Luxurious Red Fabric',
      imageType: 'foreground',
      campaignTypes: ['vehicle', 'incentive'],
      categories: ['textures', 'fabric'],
      fileName: 'texture_red-fabric.jpg'
    }
  ]);

  const handleAddMetadata = (items: Omit<MetadataItem, 'id'>[]) => {
    const newItems = items.map(item => ({
      ...item,
      id: Date.now().toString() + Math.random().toString()
    }));
    setMetadata([...metadata, ...newItems]);
  };

  const handleDeleteMetadata = (ids: string[]) => {
    setMetadata(metadata.filter(item => !ids.includes(item.id)));
  };

  const handleUpdateMetadata = (id: string, updates: Partial<MetadataItem>) => {
    setMetadata(metadata.map(item => 
      item.id === id ? { ...item, ...updates } : item
    ));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">SCM Image Metadata Management</h1>
          </div>

          <Tabs defaultValue="upload" className="w-full">
            <TabsList className="grid w-full max-w-2xl grid-cols-3">
              <TabsTrigger value="upload">Upload</TabsTrigger>
              <TabsTrigger value="edit">Edit</TabsTrigger>
              <TabsTrigger value="delete">Delete</TabsTrigger>
            </TabsList>

            <TabsContent value="upload" className="mt-6">
              <MetadataUploadForm 
                onSubmit={handleAddMetadata}
              />
            </TabsContent>

            <TabsContent value="edit" className="mt-6">
              <MetadataEditForm 
                existingMetadata={metadata}
                onUpdate={handleUpdateMetadata}
              />
            </TabsContent>

            <TabsContent value="delete" className="mt-6">
              <MetadataDeleteConsole 
                metadata={metadata}
                onDelete={handleDeleteMetadata}
              />
            </TabsContent>
          </Tabs>
        </div>
      </div>
      
      <Toaster />
    </div>
  );
}

export default App;
